import React, { Component } from 'react';
import { createRemoteVideoMenuButtonEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { translate } from '../../../base/i18n/functions';
import { IconRemoteControlStart, IconRemoteControlStop } from '../../../base/icons/svg';
import ContextMenuItem from '../../../base/ui/components/web/ContextMenuItem';
import { REMOTE_CONTROL_MENU_STATES } from '../../../remote-control/constants';
import { NOTIFY_CLICK_MODE } from '../../../toolbox/types';
export { REMOTE_CONTROL_MENU_STATES };
/**
 * Implements a React {@link Component} which displays a button showing the
 * current state of remote control for a participant and can start or stop a
 * remote control session.
 *
 * @augments Component
 */
class RemoteControlButton extends Component {
    /**
     * Initializes a new {@code RemoteControlButton} instance.
     *
     * @param {Object} props - The read-only React Component props with which
     * the new instance is to be initialized.
     */
    constructor(props) {
        super(props);
        // Bind event handlers so they are only bound once for every instance.
        this._onClick = this._onClick.bind(this);
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {null|ReactElement}
     */
    render() {
        const { remoteControlState, t } = this.props;
        let disabled = false, icon, labelKey;
        // Each state gets its own words. One label across all three read as
        // "Start / Stop remote control", which describes the toggle rather than
        // telling anyone what pressing it now would do.
        switch (remoteControlState) {
            case REMOTE_CONTROL_MENU_STATES.NOT_STARTED:
                icon = IconRemoteControlStart;
                labelKey = 'remoteControl.requestControl';
                break;
            case REMOTE_CONTROL_MENU_STATES.REQUESTING:
                disabled = true;
                icon = IconRemoteControlStart;
                labelKey = 'remoteControl.requestPending';
                break;
            case REMOTE_CONTROL_MENU_STATES.STARTED:
                icon = IconRemoteControlStop;
                labelKey = 'remoteControl.stopControlling';
                break;
            case REMOTE_CONTROL_MENU_STATES.NOT_SUPPORTED:
            // Intentionally fall through.
            default:
                return null;
        }
        return (React.createElement(ContextMenuItem, { accessibilityLabel: t(labelKey), className: 'kicklink', disabled: disabled, icon: icon, onClick: this._onClick, text: t(labelKey) }));
    }
    /**
     * Sends analytics event for pressing the button and executes the passed
     * onClick handler.
     *
     * @private
     * @returns {void}
     */
    _onClick() {
        const { notifyClick, notifyMode, onClick, participantID, remoteControlState } = this.props;
        notifyClick?.();
        if (notifyMode === NOTIFY_CLICK_MODE.PREVENT_AND_NOTIFY) {
            return;
        }
        // TODO: What do we do in case the state is e.g. "requesting"?
        if (remoteControlState === REMOTE_CONTROL_MENU_STATES.STARTED
            || remoteControlState === REMOTE_CONTROL_MENU_STATES.NOT_STARTED) {
            const enable = remoteControlState === REMOTE_CONTROL_MENU_STATES.NOT_STARTED;
            sendAnalytics(createRemoteVideoMenuButtonEvent('remote.control.button', {
                enable,
                'participant_id': participantID
            }));
        }
        onClick?.();
    }
}
export default translate(RemoteControlButton);
